import "@/styles/bootstrap.scss";
import "../styles/globals.css";

import { ApolloProvider } from "@apollo/client";
import dynamic from "next/dynamic";
import { Karla } from "next/font/google";
import Head from "next/head";
import { useRouter } from "next/router";
import Script from "next/script";
import React from "react";
import { KeepAliveProvider } from "react-next-keep-alive";

import { useApollo } from "@/apollo-client";
import AmplitudeContextProvider from "@/context/amplitude";
import CollectionProvider from "@/context/collection";
import MeProvider from "@/context/me";
import PreviousRouteProvider from "@/context/previousRoute";
import RequestIdProvider from "@/context/requestId";
import SnackbarProvider from "@/context/snackbar";
import { AnalyticsProvider } from "@/hooks/useAnalytics";

const karla = Karla({ subsets: ["latin"] });

const Bottom = dynamic(() => import("@/components/ui/bottom"), {
  ssr: true,
});

const HomeBottom = dynamic(() => import("@/components/ui/home-bottom"), {
  ssr: true,
});

export default function MyApp({ Component, pageProps }) {
  const router = useRouter();
  const apolloClient = useApollo(pageProps);
  const isHomePage = router.pathname === "/";

  React.useEffect(() => {
    const inMySize =
      typeof window !== "undefined" ? sessionStorage.getItem("inMySize") : "";
    document.cookie = `in_my_size=${inMySize}; path=/; secure; samesite=strict`;
  }, []);

  return (
    <ApolloProvider client={apolloClient}>
      <PreviousRouteProvider>
        <RequestIdProvider>
          <MeProvider>
            <AnalyticsProvider writeKey="61a29fca6134b05a8d3a">
              <div className={karla.className}>
                <Head>
                  <title>Plush</title>
                  <Script
                    dangerouslySetInnerHTML={{
                      __html: `
                    "@context": "https://schema.org",
                    "name:": "Plush",
                  `,
                    }}
                  />
                  <meta
                    name="google-site-verification"
                    content="MAWQhWb_791-majphaps94oy9UAJNJZhcPXOHu_nHjI"
                  />

                  <meta name="apple-mobile-web-app-capable" content="yes" />
                  <meta name="mobile-web-app-capable" content="yes" />
                  <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1.0, maximum-scale=1.0"
                  />

                  {/* Google Tag Manager */}
                  <Script
                    async
                    src="https://www.googletagmanager.com/gtag/js?id=G-72DYJJ8KFX"
                  ></Script>
                  <Script
                    dangerouslySetInnerHTML={{
                      __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', 'G-72DYJJ8KFX');
                  `,
                    }}
                  />
                  {/* End Google Tag Manager */}
                </Head>

                <AmplitudeContextProvider>
                  <SnackbarProvider>
                    <CollectionProvider>
                      <KeepAliveProvider router={router}>
                        <Component key={router.asPath} {...pageProps} />
                      </KeepAliveProvider>
                    </CollectionProvider>
                  </SnackbarProvider>
                  {isHomePage ? <HomeBottom /> : <Bottom />}
                </AmplitudeContextProvider>
              </div>
            </AnalyticsProvider>
          </MeProvider>
        </RequestIdProvider>
      </PreviousRouteProvider>
    </ApolloProvider>
  );
}
